import { gql } from "@apollo/client";

export default gql`
  mutation deleteSlackNotificationsForMeetingGroup($notificationId: Int!) {
    deleteSlackNotificationsForMeetingGroup(notificationId: $notificationId) {
      meetingGroup {
        id
        slackNotifications {
          edges {
            node {
              id
              channel
            }
          }
        }
      }
    }
  }
`;
